function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.529 2.764H0",
  clipRule: "evenodd",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "inherit",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.529 5.529",
    strokeWidth: 0.25
  }, props), _ref);
}

export default SvgMinus;